var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWp = function SvgWp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#535C79",
    d: "m1.503 16.5 1.014-3.726a7.5 7.5 0 1 1 2.71 2.71zm4.79-11.019a.7.7 0 0 0-.278.075 1 1 0 0 0-.22.171c-.09.085-.141.158-.196.23-.277.36-.427.803-.424 1.258.002.367.098.725.248 1.06.306.676.811 1.393 1.478 2.056.16.16.317.32.486.47a7.1 7.1 0 0 0 2.88 1.534l.427.065c.138.008.277-.002.416-.01.219-.01.432-.07.625-.173.125-.066.183-.099.288-.165q0 .002.093-.067a1.7 1.7 0 0 0 .248-.216.9.9 0 0 0 .157-.226 2 2 0 0 0 .141-.55c.018-.149.013-.23.01-.28-.002-.08-.069-.163-.142-.199l-.436-.195s-.653-.285-1.051-.466a.4.4 0 0 0-.133-.031.36.36 0 0 0-.283.095v-.001c-.004 0-.054.043-.597.7a.26.26 0 0 1-.275.097 1 1 0 0 1-.144-.05l-.189-.081-.003-.002a4.5 4.5 0 0 1-1.178-.75c-.094-.082-.182-.172-.272-.26a4.7 4.7 0 0 1-.765-.95l-.044-.071a.7.7 0 0 1-.077-.154.24.24 0 0 1 .046-.199s.182-.2.267-.308q.105-.135.197-.28c.089-.142.116-.288.07-.401a62 62 0 0 0-.651-1.531c-.044-.1-.176-.173-.295-.187l-.121-.012a3 3 0 0 0-.303.003z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgWp;